import { render } from "./IconFavorite40px.vue?vue&type=template&id=b31f229c"
import script from "./IconFavorite40px.vue?vue&type=script&lang=js"
export * from "./IconFavorite40px.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__